import { useState } from 'react';
import { X, Plus } from '@phosphor-icons/react';
import { Input } from '@/components/ui/input';

/**
 * Chip-style email input. Add via Enter / comma / blur.
 */
export default function EmailChipsInput({ value = [], onChange, placeholder = 'メールアドレスを入力', testId }) {
  const [draft, setDraft] = useState('');

  const isValid = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

  const commit = (raw) => {
    const tokens = raw
      .split(/[,\n;\s]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    if (!tokens.length) return;
    const next = [...value];
    for (const t of tokens) {
      if (!isValid(t)) continue;
      if (!next.includes(t)) next.push(t);
    }
    onChange(next);
    setDraft('');
  };

  const remove = (email) => {
    onChange(value.filter((e) => e !== email));
  };

  const handleKey = (e) => {
    if (['Enter', ',', ';', ' '].includes(e.key)) {
      e.preventDefault();
      commit(draft);
    } else if (e.key === 'Backspace' && !draft && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2 p-2 border border-zinc-300 rounded-md bg-white min-h-[42px] focus-within:ring-2 focus-within:ring-blue-500">
        {value.map((email) => (
          <span
            key={email}
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 text-xs font-medium border border-blue-200"
            data-testid={`email-chip-${email}`}
          >
            {email}
            <button
              type="button"
              onClick={() => remove(email)}
              className="hover:bg-blue-200 rounded-full p-0.5"
              data-testid={`btn-remove-email-${email}`}
            >
              <X size={10} weight="bold" />
            </button>
          </span>
        ))}
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={handleKey}
          onBlur={() => commit(draft)}
          placeholder={value.length === 0 ? placeholder : ''}
          data-testid={testId}
          className="flex-1 min-w-[140px] outline-none text-sm bg-transparent"
        />
      </div>
      <p className="text-xs text-zinc-500">
        Enter / カンマで追加。複数のメールアドレスを登録できます。
      </p>
    </div>
  );
}
